import React, { useState, useEffect } from "react";
import { Modal } from "@material-ui/core";
import { Button, Form } from "react-bootstrap";
import { MDBCard, MDBCardBody, MDBCardTitle } from "mdb-react-ui-kit";
import { useTranslation } from "react-i18next";
import { authenticatedRequest } from "../../../config/axios";
import {
  adminAllConsultation,
  adminAllSubscriptions,
  adminGetPartnesList,
  getAdminAllDoctors,
  getAdminAllSecretaries,
} from "../../../config/service";
import { toast } from "react-toastify";
// import DatePicker from "react-date-picker";
import DatePicker from "react-datepicker";
import AdminImageCropper from "./AdminImageCropper";
import profilePic from "../../../assets/images/dashboard/docProfile.png";
import Multiselect from "multiselect-react-dropdown";
import { handleKeyPress } from "../../Login/login";
import { checkEmailFormate, formattedDate } from "../../../utils/function";
import moment from "moment";
import { RotatingLines } from "react-loader-spinner";

const UpdateDetails = (props) => {
  const { t } = useTranslation();
  const lang = localStorage.getItem("lang");
  const {
    userdata,
    profileData,
    profileLoading,
    selectedValue,
    id,
    setSelectedType,
    selectedtype,
    setCalenderInvite,
    calenderInvite,
    setSelectedSubscriptions,
    selectedSubscriptions,
    connectedUsers,
    selectedDoctorId,
    selectedSecretaryId,
  } = props;
  const [modalShow, setModalShow] = useState(false);
  const [consultData, setConsultData] = useState([]);
  const [typevalue, setTypeValue] = useState([]);
  const [calendarEmail, setCalendarEmail] = useState();
  const [subscriptionsList, setSubscriptionsList] = useState([]);
  const [subscriptionsValue, setSubscriptionsValue] = useState([]);
  const [selectedPartners, setSelectedPartners] = useState([]);
  const [isPassport, setIsPassport] = useState(false);
  const [clientDOB, setClientDOB] = useState(null);
  const [doctorList, setDoctorList] = useState([]);
  const [secretaryList, setSecretaryList] = useState([]);

  const [partnersList, setPartnersList] = useState([]);
  const patienttype = [
    { eng: "Children", heb: "ילד.ה" },
    { eng: "Adults", heb: "מבוגר" },
  ];
  const [formValue, setformValue] = React.useState({
    email: "",
    first_name: "",
    last_name: "",
    id: "",
    phone: "",
    password: "",
    role: "",
    dob: "",
    sex: "",
    MaritalStatus: "",
    permanent: "",
    street: "",
    postalcode: "",
    localphoneNumber: "",
    city: "",
    houseNo: "",
    country: "Israel",
    doctor_license: "",
    title: "",
    speciality: [],
    experience: "",
    bio: "",
    UTM: "",
    collective: "",
    personalId: "",
    partnerId: "",
    signatureUser: "",
    signaturePassword: "",
  });

  useEffect(() => {
    consultingFields();
    getSubscriptionsList();
    getPartnersList();
  }, []);

  useEffect(() => {
    if (userdata?.role === "secretary") {
      allDoctorList();
    }
    if (userdata.role === "doctor") {
      allSecretaryList();
    }
  }, [userdata]);

  useEffect(() => {
    if (profileData?.partnerId?.length > 0) {
      setSelectedPartners(
        partnersList?.filter((list) => {
          if (profileData?.partnerId.includes(list._id)) {
            return list;
          }
        })
      );
    }
  }, [profileData, partnersList]);

  const consultingFields = async () => {
    const response = await adminAllConsultation();
    setConsultData(response.data.result);
  };
  const onSelectType = (selectedList, selectedItem) => {
    setSelectedType((prevSelectedType) => [...prevSelectedType, selectedItem]);
  };

  const onRemoveType = (selectedList, removedItem) => {
    setSelectedType((prevSelectedType) =>
      prevSelectedType.filter((d) => d !== removedItem)
    );
  };

  const allDoctorList = async () => {
    try {
      const response = await getAdminAllDoctors();
      setDoctorList(response.data.result);
    } catch (error) {
      console.log(error);
    }
  };

  const allSecretaryList = async () => {
    try {
      const response = await getAdminAllSecretaries();
      setSecretaryList(response.data.result);
    } catch (error) {
      console.log(error);
    }
  };

  const getConnectedIds = () =>
    profileData?.connectedUsers?.map((u) => u?._id) || [];

  useEffect(() => {
    if (profileData?.role === "secretary" && doctorList.length > 0) {
      const connectedIds = getConnectedIds();

      const matchedDoctors = doctorList.filter((doctor) =>
        connectedIds.includes(doctor.userId)
      );

      props.setConnectedUsers(matchedDoctors);
      props.setSelectDoctorId(connectedIds);
    }
  }, [doctorList, profileData]);

  useEffect(() => {
    if (profileData?.role === "doctor" && secretaryList.length > 0) {
      const connectedIds = getConnectedIds();

      const matchedSecretaries = secretaryList.filter((secretary) =>
        connectedIds.includes(secretary.userId)
      );

      props.setConnectedUsers(matchedSecretaries);
      props.setSelectSecretaryId(connectedIds);
    }
  }, [secretaryList, profileData]);

  const onUserSelect = (selectedList) => {
    props.setConnectedUsers(selectedList);

    const ids = selectedList.map((d) => d.userId);

    if (profileData.role === "secretary") props.setSelectDoctorId(ids);
    if (profileData.role === "doctor") props.setSelectSecretaryId(ids);
  };

  const onUserRemove = (selectedList) => {
    props.setConnectedUsers(selectedList);

    const ids = selectedList.map((d) => d.userId);

    if (profileData.role === "secretary") props.setSelectDoctorId(ids);
    if (profileData.role === "doctor") props.setSelectSecretaryId(ids);
  };

  useEffect(() => {
    const updatedTypeValue = selectedtype.map((item) => item.eng);
    setTypeValue(updatedTypeValue);
  }, [selectedtype]);
  const onSelectSubscriptions = (selectedList, selectedItem) => {
    setSelectedSubscriptions([...selectedSubscriptions, selectedItem]);
    setSubscriptionsValue([...subscriptionsValue, selectedItem]);
  };

  // const onSelectPartner = (selectedList, selectedItem) => {
  //   // setSelectedPartner([...selectedSubscriptions, selectedItem]);
  //   setPartnerValue([...partnerValue, selectedItem]);
  // };

  // const onRemovePartners = (selectedList, removedItem) => {
  //   // setSelectedSubscriptions(
  //   //   selectedSubscriptions.filter((d) => {
  //   //     return d != removedItem;
  //   //   })
  //   // );
  //   setPartnerValue(
  //     setPartnerValue.filter((d) => {
  //       return d != removedItem;
  //     })
  //   );
  // };

  const onRemoveSubscriptions = (selectedList, removedItem) => {
    setSelectedSubscriptions(
      selectedSubscriptions.filter((d) => {
        return d != removedItem;
      })
    );
    setSubscriptionsValue(
      subscriptionsValue.filter((d) => {
        return d != removedItem;
      })
    );
  };

  const [imageData1, setImageData1] = useState();
  const ImageThumb = ({ image }) => {
    return <img src={image} />;
  };
  const handleChange = (event) => {
    const { name } = event.target;
    if (name === "passportNumber") {
      setIsPassport(!isPassport);
    } else
      setformValue({
        ...formValue,
        [event.target.name]: event.target.value,
      });
  };

  const formattedDOB = (date) => {
    if (!date || !moment(date).isValid()) {
      return null;
    }
    return moment(date).hour(12).minute(0).locale("en").toISOString();
  };

  const handleDOBChange = (date) => {
    props.setDOB(date);
    setClientDOB(formattedDOB(date));
  };

  const handleSetDOB = () => {
    setClientDOB(formattedDOB(props.value));
  };

  useEffect(() => {
    handleSetDOB();
  }, [props.value]);

  const onSelect = (selectedList, selectedItem) => {
    props.setSelectedValue([...selectedValue, selectedItem]);
    props.setSelectId([...id, selectedItem._id]);
  };

  const onRemove = (selectedList, removedItem) => {
    props.setSelectedValue(
      props.selectedValue.filter((d) => {
        return d != removedItem;
      })
    );
    props.setSelectId(
      id.filter((d) => {
        return d != removedItem._id;
      })
    );
  };
  function handleUpload() {
    setModalShow(true);
  }
  const getSubscriptionsList = async () => {
    try {
      const response = await adminAllSubscriptions();
      setSubscriptionsList(response.data.subscriptions);
    } catch (error) {
      console.log(error);
    }
  };
  const getPartnersList = async () => {
    try {
      const response = await adminGetPartnesList();
      setPartnersList(response?.data?.partners);
    } catch (error) {
      console.log(error);
    }
  };

  const Updatedata = async () => {
    const data = {
      email: formValue.email ? formValue.email : profileData?.email,
      first_name: formValue.first_name
        ? formValue.first_name
        : profileData.first_name,
      last_name: formValue.last_name
        ? formValue.last_name
        : profileData?.last_name,
      id: formValue.id ? formValue.id : profileData?.id,
      phone: formValue.phone ? formValue.phone : profileData?.phone,
      password: formValue.password ? formValue.password : "",
      role: formValue.role ? formValue.role : profileData?.role,
      clientDOB: clientDOB,
      clientGender: formValue.sex ? formValue.sex : profileData?.clientGender,
      clientMaritalStatus: formValue.MaritalStatus
        ? formValue.MaritalStatus
        : profileData?.clientMaritalStatus,
      permanentOrRetired: formValue.permanent
        ? formValue.permanent
        : profileData?.permanentOrRetired,
      sendCalendarInvite: calenderInvite,
      calendarEmail: calendarEmail,
      clientAddress: {
        street: formValue.street
          ? formValue.street
          : profileData?.clientAddress?.street,
        pincode: formValue.postalcode
          ? formValue.postalcode
          : profileData?.clientAddress?.pincode,
        localPhone: formValue.localphoneNumber
          ? formValue.localphoneNumber
          : profileData.clientAddress?.localPhone,
        city: formValue.city
          ? formValue.city
          : profileData?.clientAddress?.city,
        house: formValue.houseNo
          ? formValue.houseNo
          : profileData?.clientAddress?.house,
        country: formValue.country
          ? formValue.country
          : profileData?.clientAddress?.country,
      },

      licenceNumber: formValue.doctor_license
        ? formValue.doctor_license
        : profileData?.doctorPersonalData?.licenceNumber,
      title: formValue.title
        ? formValue.title
        : profileData?.doctorPersonalData?.title,
      consultationSpeciality:
        id.length != 0
          ? id
          : profileData?.doctorPersonalData?.consultationSpeciality,
      experience: formValue.experience
        ? formValue.experience
        : profileData?.doctorPersonalData?.experience,
      patientsCategory:
        typevalue.length != 0
          ? typevalue
          : profileData?.doctorPersonalData?.patientsCategory,
      bio: formValue.bio ? formValue.bio : profileData?.doctorPersonalData?.bio,

      UTM: formValue.UTM ? formValue.UTM : profileData?.UTM,
      collective: formValue.collective
        ? formValue.collective
        : profileData?.collective,
      insuranceConsent: formValue.insuranceConsent
        ? formValue.insuranceConsent
        : profileData?.insuranceConsent,
      personalId: formValue.personalId
        ? formValue.personalId
        : profileData.personalId,
      subscriptions:
        selectedSubscriptions.length !== 0
          ? selectedSubscriptions
          : profileData?.doctorPersonalData?.subscriptions,
      partnerId: selectedPartners[0]?._id ? selectedPartners[0]?._id : [],
      passportNumber: isPassport,
      signatureUser:
        formValue.signatureUser ||
        profileData?.doctorPersonalData?.signatureUser,
      signaturePassword:
        formValue.signaturePassword ||
        profileData?.doctorPersonalData?.signaturePassword,
      connectedUsers:
        profileData.role === "doctor"
          ? selectedSecretaryId || []
          : profileData.role === "secretary"
          ? selectedDoctorId || []
          : [],
    };
    const isEmailCorrect = checkEmailFormate(data?.email);
    if (!isEmailCorrect) {
      toast.error("Please enter valid email");
      return;
    }
    try {
      const response = await authenticatedRequest({
        method: "patch",
        url: `/admin/updateUserById/${props.updateId}`,
        data: data,
        headers: {
          "Content-Type": "application/json",
        },
      });
      if ([200, 201, 202].includes(response.status)) {
        toast.success(t(response.data.msg));
        setformValue({
          email: "",
          first_name: "",
          last_name: "",
          id: "",
          phone: "",
          password: "",
          role: "",
          dob: "",
          sex: "",
          MaritalStatus: "",
          permanent: "",
          street: "",
          postalcode: "",
          localphoneNumber: "",
          city: "",
          houseNo: "",
          country: "Israel",
          doctor_license: "",
          title: "",
          speciality: [],
          experience: "",
          bio: "",
          UTM: "",
          collective: "",
          personalId: "",
          signatureUser: "",
          signaturePassword: "",
        });
        props.handleClose();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleCheckPassport = () => {
    if (profileData && Object.hasOwn(profileData, "passportNumber")) {
      setIsPassport(profileData?.passportNumber);
    }
  };

  useEffect(() => {
    handleCheckPassport();
  }, [profileData]);

  return (
    <div>
      <Modal
        open={modalShow}
        onClose={() => setModalShow(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="imagecropmodal"
      >
        <>
          <AdminImageCropper
            handleClose={() => setModalShow(false)}
            setImageData1={setImageData1}
            doctorId={props.doctorId}
          />
        </>
      </Modal>
      <Modal
        open={props.updateModal}
        onClose={() => props.setUpdateModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="modalDiv"
        style={{
          backgroundColor: "#FFFFFF",
          width: "80%",
          margin: "30px auto",
          height: "auto",
          borderRadius: "35px",
        }}
      >
        <MDBCard className="documentBody update-doctor-detail">
          <MDBCardBody>
            {profileLoading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ width: "100%", height: "100%" }}
              >
                <RotatingLines
                  strokeColor="grey"
                  strokeWidth="5"
                  animationDuration="0.75"
                  width="64"
                  visible={true}
                />
              </div>
            ) : (
              <>
                <MDBCardTitle className="headerText">
                  {profileData?.role == "doctor" &&
                    t("Update Physician Details")}
                  {profileData?.role == "client" &&
                    t("View User/Update User Details")}
                </MDBCardTitle>
                {profileData?.role == "doctor" ? (
                  <div className="team-profile-img" onClick={handleUpload}>
                    {profileData?.role == "doctor" ? (
                      imageData1 == null ? (
                        <img
                          src={
                            profileData ? profileData.croppedAvatar : profilePic
                          }
                          alt=""
                        />
                      ) : (
                        imageData1 && <ImageThumb image={imageData1} />
                      )
                    ) : null}
                  </div>
                ) : null}
                {profileData?.first_name && (
                  <Form className="form">
                    <div className="updatemodal-form">
                      <Form.Group className="frequency">
                        <Form.Label> {t("First Name")}</Form.Label>
                        <input
                          type="text"
                          className="form-control"
                          name="first_name"
                          onChange={handleChange}
                          id="first_name"
                          defaultValue={
                            profileData?.first_name
                              ? profileData.first_name
                              : ""
                          }
                        />
                      </Form.Group>
                      <Form.Group className="frequency">
                        <Form.Label> {t("Last Name")}</Form.Label>
                        <input
                          type="text"
                          className="form-control"
                          name="last_name"
                          onChange={handleChange}
                          id="last_name"
                          defaultValue={
                            profileData?.last_name ? profileData.last_name : ""
                          }
                        />
                      </Form.Group>
                      <Form.Group className="frequency">
                        <Form.Label> {t("Email")}</Form.Label>
                        <input
                          type="text"
                          className="form-control"
                          defaultValue={
                            profileData?.email ? profileData.email : ""
                          }
                          name="email"
                          onChange={handleChange}
                          id="email"
                        />
                      </Form.Group>
                      <Form.Group className="frequency">
                        {profileData?.role == "client" ? (
                          <Form.Label className={`id-label ${isPassport}`}>
                            {" "}
                            <p
                              className={` ${isPassport ? "label-active" : ""}`}
                            >
                              {" "}
                              {t("Id Number")}
                            </p>
                            <div
                              className={`slideThree ${isPassport} ${lang}`}
                              data-translation={
                                !isPassport ? t("Passport") : t("Id Number")
                              }
                            >
                              <input
                                type="checkbox"
                                value="None"
                                id="slideThree"
                                name="passportNumber"
                                checked={isPassport}
                                onChange={handleChange}
                              />
                              <label for="slideThree"></label>
                            </div>
                            <p
                              className={`${!isPassport ? "label-active" : ""}`}
                            >
                              {" "}
                              {t("Passport")}
                            </p>
                          </Form.Label>
                        ) : (
                          <Form.Label>{t("ID Number")}</Form.Label>
                        )}
                        <input
                          type="text"
                          className="form-control"
                          name="id"
                          onChange={handleChange}
                          id="id"
                          onWheel={(e) => e.target.blur()}
                          defaultValue={profileData?.id ? profileData.id : ""}
                          onKeyPress={handleKeyPress}
                          onInput={(e) =>
                            (e.target.value = e.target.value.slice(0, 14))
                          }
                        />
                      </Form.Group>
                      <Form.Group className="frequency">
                        <Form.Label> {t("Phone Number")}</Form.Label>
                        <input
                          type="text"
                          className="form-control phone_number"
                          name="phone"
                          onChange={handleChange}
                          id="phone"
                          defaultValue={
                            profileData?.phone ? profileData.phone : ""
                          }
                        />
                      </Form.Group>
                      <Form.Group className="frequency">
                        <Form.Label> {t("Role")}</Form.Label>
                        {profileData?.role && (
                          <select
                            className="form-control"
                            name="role"
                            onChange={handleChange}
                            id="role"
                            defaultValue={
                              profileData?.role ? profileData.role : ""
                            }
                          >
                            <option>{t("Select")}</option>
                            <option value="doctor">{t("Doctor")}</option>
                            <option value="client">{t("Client")}</option>
                            <option value="secretary">{t("Secretary")}</option>
                          </select>
                        )}
                      </Form.Group>
                      <Form.Group className="frequency">
                        <Form.Label>{t("Date of Birth")}</Form.Label>
                        <DatePicker
                          selected={props.value}
                          onChange={handleDOBChange}
                          className="form-control"
                          dateFormat="dd-MM-y"
                          showYearDropdown
                          yearDropdownItemNumber={15}
                          scrollableYearDropdown
                        />
                      </Form.Group>
                      <Form.Group className="frequency">
                        <Form.Label>{t("Gender")} </Form.Label>

                        <select
                          className="form-control"
                          name="sex"
                          // value={formValue.sex}
                          onChange={handleChange}
                          defaultValue={
                            profileData?.clientGender
                              ? profileData?.clientGender
                              : ""
                          }
                        >
                          <option value="Male">{t("Male")}</option>
                          <option value="Female">{t("Female")}</option>
                          <option value="Other"> {t("Other")}</option>
                        </select>
                      </Form.Group>
                      <Form.Group className="frequency">
                        <Form.Label>{t("Marital Status")} </Form.Label>
                        <select
                          className="form-control"
                          name="MaritalStatus"
                          // value={formValue.MaritalStatus}
                          onChange={handleChange}
                          defaultValue={
                            profileData?.clientMaritalStatus
                              ? profileData?.clientMaritalStatus
                              : ""
                          }
                        >
                          <option value="Married">{t("Married")}</option>
                          <option value="Unmarried">{t("Unmarried")}</option>
                        </select>
                      </Form.Group>
                      {profileData?.personalId ||
                      profileData?.personalId === "" ? (
                        <Form.Group className="frequency">
                          <Form.Label>{t("Personal ID Number")} </Form.Label>
                          <input
                            type="number"
                            className="form-control"
                            name="personalId"
                            onChange={handleChange}
                            onWheel={(e) => e.target.blur()}
                            id="personalId"
                            defaultValue={
                              profileData?.personalId
                                ? profileData?.personalId
                                : ""
                            }
                            onKeyPress={handleKeyPress}
                            onInput={(e) =>
                              (e.target.value = e.target.value.slice(0, 14))
                            }
                          />
                        </Form.Group>
                      ) : null}
                      {profileData?.role == "client" && (
                        <Form.Group className="frequency">
                          <Form.Label>{t("UTM")}</Form.Label>
                          <input
                            className="form-control"
                            name="UTM"
                            type="text"
                            // value={formValue.phoneNumber}
                            onChange={handleChange}
                            defaultValue={
                              profileData?.UTM ? profileData.UTM : ""
                            }
                          />
                        </Form.Group>
                      )}
                      <Form.Group className="frequency">
                        <Form.Label>{t("Ayalon customer")} </Form.Label>

                        <select
                          className="form-control"
                          name="insuranceConsent"
                          // value={formValue.sex}
                          onChange={handleChange}
                          defaultValue={profileData?.insuranceConsent}
                        >
                          <option value="true">True</option>
                          <option value="false">False</option>
                        </select>
                      </Form.Group>
                      {profileData?.role == "client" && (
                        <>
                          <Form.Group className="frequency">
                            <Form.Label>{t("Collective")}</Form.Label>
                            <input
                              className="form-control"
                              name="collective"
                              type="text"
                              // value={formValue.phoneNumber}
                              onChange={handleChange}
                              defaultValue={
                                profileData?.Collective
                                  ? profileData.Collective
                                  : ""
                              }
                            />
                          </Form.Group>
                        </>
                      )}

                      {(profileData?.role === "secretary" ||
                        profileData?.role === "doctor") && (
                        <Form.Group className="frequency">
                          <Form.Label>{t("Relations")}</Form.Label>
                          <Multiselect
                            className="form-control"
                            options={
                              profileData?.role === "doctor"
                                ? secretaryList
                                : profileData?.role === "secretary"
                                ? doctorList
                                : []
                            }
                            displayValue="full_name"
                            selectedValues={connectedUsers}
                            onSelect={onUserSelect}
                            onRemove={onUserRemove}
                            placeholder="Select"
                            id="connectedUsers"
                          />
                        </Form.Group>
                      )}

                      {profileData?.role == "doctor" && (
                        <>
                          <Form.Group className="frequency">
                            <Form.Label>{t("Password")}</Form.Label>
                            <input
                              className="form-control"
                              name="password"
                              type="text"
                              // value={formValue.phoneNumber}
                              onChange={handleChange}
                              id="password"
                            />
                          </Form.Group>
                          <Form.Group className="frequency">
                            <Form.Label>{t("Doctor license")}</Form.Label>
                            <input
                              className="form-control"
                              name="doctor_license"
                              type="number"
                              // value={formValue.phoneNumber}
                              onChange={handleChange}
                              id="doctor_license"
                              defaultValue={
                                profileData?.doctorPersonalData?.licenceNumber
                                  ? profileData?.doctorPersonalData
                                      ?.licenceNumber
                                  : ""
                              }
                            />
                          </Form.Group>
                          <Form.Group className="frequency">
                            <Form.Label>{t("Specilization")} </Form.Label>
                            <Multiselect
                              className="form-control"
                              options={consultData}
                              getOptionLabel={(option) => option.eng}
                              selectedValues={selectedValue}
                              onSelect={onSelect}
                              onRemove={onRemove}
                              displayValue={"eng"}
                              placeholder=""
                              id="consult"
                            />
                          </Form.Group>
                          <Form.Group className="frequency">
                            <Form.Label>{t("Title")}</Form.Label>
                            <select
                              className="form-control"
                              name="title"
                              onChange={handleChange}
                              defaultValue={
                                profileData?.doctorPersonalData?.title
                                  ? profileData?.doctorPersonalData?.title
                                  : ""
                              }
                            >
                              <option value="Professor">
                                {t("Professor")}
                              </option>
                              <option value="Doctor">{t("Doctor")}</option>
                            </select>
                          </Form.Group>
                          <Form.Group className="frequency">
                            <Form.Label>
                              {t("Practice")} / {t("Experience")}
                            </Form.Label>
                            <input
                              className="form-control"
                              name="experience"
                              type="text"
                              // value={formValue.phoneNumber}
                              onChange={handleChange}
                              id="experience"
                              defaultValue={
                                profileData?.doctorPersonalData?.experience
                                  ? profileData?.doctorPersonalData?.experience
                                  : ""
                              }
                            />
                          </Form.Group>
                          <Form.Group className="frequency">
                            <Form.Label>{t("Bio")}</Form.Label>
                            <textarea
                              className="form-control"
                              maxlength="300"
                              name="bio"
                              type="text"
                              // value={formValue.phoneNumber}
                              onChange={handleChange}
                              id="bio"
                              defaultValue={
                                profileData?.doctorPersonalData?.bio
                                  ? profileData?.doctorPersonalData?.bio
                                  : ""
                              }
                            />
                          </Form.Group>
                          <Form.Group className="frequency">
                            <Form.Label>{t("Patient Type")} </Form.Label>
                            <Multiselect
                              className="form-control"
                              options={patienttype}
                              selectedValues={selectedtype}
                              onSelect={onSelectType}
                              onRemove={onRemoveType}
                              displayValue={lang === "EN" ? "eng" : "heb"}
                              placeholder=""
                            />
                          </Form.Group>
                          <Form.Group className="frequency">
                            <Form.Label>{t("Subscriptions")} </Form.Label>
                            <Multiselect
                              className="form-control"
                              options={subscriptionsList}
                              selectedValues={selectedSubscriptions}
                              onSelect={onSelectSubscriptions}
                              onRemove={onRemoveSubscriptions}
                              placeholder=""
                              isObject={false}
                            />
                          </Form.Group>
                          <Form.Group className="frequency">
                            <Form.Label>{t("Partner")} </Form.Label>

                            <Multiselect
                              className="form-control"
                              options={partnersList}
                              displayValue="partnerName"
                              onSelect={(selectedList) =>
                                setSelectedPartners(selectedList)
                              }
                              onRemove={(selectedList) =>
                                setSelectedPartners(selectedList)
                              }
                              selectedValues={selectedPartners}
                              isObject={true}
                              selectionLimit={1}
                              closeOnSelect={true}
                            />

                            {/* 
                            <select
                              className="form-control"
                              id="partner"
                              name="partnerId"
                              value={formValue.partner}
                              onChange={handleChange}
                              defaultValue={profileData?.partnerId}
                            >
                              <option value="">{t("Select")}</option>
                              {partnersList &&
                                partnersList.map((el) => (
                                  <option
                                    selected={(profileData?.partnerId.indexOf(el?._id) > -1) ? true : false}
                                    value={el?._id}
                                  >
                                    {el?.partnerName}
                                  </option>
                                ))}
                            </select> */}
                          </Form.Group>
                        </>
                      )}

                      <Form.Group className="frequency">
                        <Form.Label>{t("Street")}</Form.Label>
                        <input
                          className="form-control"
                          name="street"
                          type="text"
                          // value={formValue.phoneNumber}
                          onChange={handleChange}
                          id="street"
                          defaultValue={
                            profileData?.clientAddress?.street
                              ? profileData.clientAddress.street
                              : ""
                          }
                        />
                      </Form.Group>
                      <Form.Group className="frequency">
                        <Form.Label>{t("House No")}</Form.Label>
                        <input
                          className="form-control"
                          name="houseNo"
                          type="text"
                          // value={formValue.phoneNumber}
                          onChange={handleChange}
                          id="houseNo"
                          defaultValue={
                            profileData?.clientAddress?.house
                              ? profileData.clientAddress.house
                              : ""
                          }
                        />
                      </Form.Group>
                      <Form.Group className="frequency">
                        <Form.Label>{t("City")}</Form.Label>
                        <input
                          className="form-control"
                          name="city"
                          type="text"
                          // value={formValue.phoneNumber}
                          onChange={handleChange}
                          id="city"
                          defaultValue={
                            profileData?.clientAddress?.city
                              ? profileData.clientAddress.city
                              : ""
                          }
                        />
                      </Form.Group>
                      <Form.Group className="frequency">
                        <Form.Label>{t("Country")} </Form.Label>
                        <input
                          className="form-control"
                          name="country"
                          type="text"
                          id="country"
                          onChange={handleChange}
                          defaultValue={
                            profileData?.clientAddress?.country
                              ? profileData.clientAddress.country
                              : ""
                          }
                        />
                      </Form.Group>
                      <Form.Group className="frequency">
                        <Form.Label>{t("Postal Code")}</Form.Label>
                        <input
                          className="form-control"
                          name="postalcode"
                          type="tel"
                          // value={formValue.phoneNumber}
                          onChange={handleChange}
                          id="postalcode"
                          dir="auto"
                          defaultValue={
                            profileData?.clientAddress?.pincode
                              ? profileData.clientAddress.pincode
                              : ""
                          }
                        />
                      </Form.Group>
                      {profileData?.role == "doctor" && (
                        <>
                          <Form.Group className="frequency">
                            <Form.Label className="email-lable">
                              {t(
                                "E-mail for calendar invitations (If different from the main e-mail address)"
                              )}
                            </Form.Label>
                            <input
                              className="form-control"
                              name="calendarEmail"
                              type="tel"
                              // value={formValue.phoneNumber}
                              onChange={(e) => setCalendarEmail(e.target.value)}
                              id="postalcode"
                              dir="auto"
                              defaultValue={
                                profileData?.doctorPersonalData?.calendarEmail
                                  ? profileData?.doctorPersonalData
                                      ?.calendarEmail
                                  : ""
                              }
                            />
                          </Form.Group>

                          <Form.Group className="frequency">
                            <Form.Label className="email-lable">
                              {t("Registration Date")}
                            </Form.Label>
                            <input
                              className="form-control"
                              name="calendarEmail"
                              type="text"
                              readOnly
                              id="resgistrationDate"
                              dir="auto"
                              defaultValue={formattedDate(
                                profileData?.createdAt
                              )}
                            />
                          </Form.Group>

                          <Form.Group className="frequency">
                            <Form.Label>{t("Signature Username")}</Form.Label>
                            <input
                              className="form-control"
                              name="signatureUser"
                              type="text"
                              onChange={handleChange}
                              id="signatureUser"
                              defaultValue={
                                profileData?.doctorPersonalData?.signatureUser
                                  ? profileData?.doctorPersonalData
                                      ?.signatureUser
                                  : ""
                              }
                            />
                          </Form.Group>
                          <Form.Group className="frequency">
                            <Form.Label>{t("Signature Password")}</Form.Label>
                            <Form.Control
                              name="signaturePassword"
                              type="text"
                              onChange={handleChange}
                              id="signaturePassword"
                              className="text-center"
                              autoComplete="new-password"
                              defaultValue={
                                profileData?.doctorPersonalData
                                  ?.signaturePassword
                                  ? profileData?.doctorPersonalData
                                      ?.signaturePassword
                                  : ""
                              }
                            />
                          </Form.Group>
                        </>
                      )}
                    </div>
                    {profileData?.role == "doctor" && (
                      <div className="check pt-2">
                        <input
                          type="checkbox"
                          checked={calenderInvite}
                          onClick={() => setCalenderInvite(!calenderInvite)}
                        />
                        <span>
                          {" "}
                          {t("Get calendar invitations for meetings")}
                        </span>
                      </div>
                    )}
                  </Form>
                )}

                <div style={{ margin: "0 auto" }}>
                  <Button size="lg" onClick={Updatedata}>
                    {" "}
                    {t("Submit")}
                  </Button>
                </div>
              </>
            )}
          </MDBCardBody>
        </MDBCard>
      </Modal>
    </div>
  );
};
export default UpdateDetails;
